import { useState } from 'react';

export default function useGroups(getGroupsQuery: any, customSkip?: number) {
	const [page, setPage] = useState(1);
	const getGroups = (filter: any) => {
		const skip = customSkip ?? 20;
		getGroupsQuery({
			...filter,
			pagination: {
				...filter.pagination,
				skip: (page - 1) * skip,
			},
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return { getGroups, getNextPage, page, setPage };
}
